module.exports = __webpack_public_path__ + "dash_20_app_assets/img/decore-right.da0ab5cd.png";